module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model) ? _c('div', {
    attrs: {
      "id": "updateHeight"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateHeightSettings.apply(null, arguments)
      }
    }
  }, [(!_vm.model.cm) ? _c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:8'),
      expression: "'required|min_value:0|max_value:8'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_ft",
      "data-vv-as": "ft",
      "errorText": _vm.errors.first('height_ft'),
      "min": 0,
      "max": 8,
      "hintText": _vm.$t('message.placeholderText'),
      "label": "ft",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.ft),
      callback: function($$v) {
        _vm.$set(_vm.model, "ft", _vm._n($$v))
      },
      expression: "model.ft"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:0|max_value:11'),
      expression: "'required|min_value:0|max_value:11'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "height_in",
      "data-vv-as": "in",
      "errorText": _vm.errors.first('height_in'),
      "min": 0,
      "max": 11,
      "hintText": _vm.$t('message.placeholderText'),
      "label": "in",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.in),
      callback: function($$v) {
        _vm.$set(_vm.model, "in", _vm._n($$v))
      },
      expression: "model.in"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.model.cm) ? _c('div', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:50|max_value:251'),
      expression: "'required|min_value:50|max_value:251'"
    }],
    attrs: {
      "data-vv-name": "height_cm",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "cm",
      "min": 0,
      "max": 251,
      "errorText": _vm.errors.first('height_cm'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": "cm"
    },
    model: {
      value: (_vm.model.cm),
      callback: function($$v) {
        _vm.$set(_vm.model, "cm", _vm._n($$v))
      },
      expression: "model.cm"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.updateText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateHeightSettings.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6c99936","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Height/Height.vue
// module id = 3304
// module chunks = 1